<template>
  <div>
    <div>
      <el-select
        id="bed-rail-select"
        v-close-on-zoom
        :value="state.bedRailAction"
        placeholder="Bed Rail Procedure"
        class="bed-rail-select"
        :disabled="readonly"
        @input="bedRailAction => setBedRailAction(bedRailAction)"
      >
        <el-option
          label="Raise Bedrail"
          value="RAISE_BED_RAIL"
        />
        <el-option
          label="Lower Bedrail"
          value="LOWER_BED_RAIL"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';

export default {
  name: 'bed-rail-action',
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        bedRailAction: 'RAISE_BED_RAIL',
      },
    };
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.bedRailAction = get(data, 'id') || 'RAISE_BED_RAIL';
    this.update();
  },
  methods: {
    setBedRailAction(bedRailAction) {
      this.state.bedRailAction = bedRailAction;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'PROCEDURE',
        id: this.state.bedRailAction,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
</style>
